var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('webpay-header-landing'),_c('main',{staticClass:"container"},[_c('div',{staticClass:"dummy-band"}),_c('div',{staticClass:"doc-content"},[_vm._t("doc-content")],2)]),_c('webpay-footer-landing',{staticClass:"push-down-for-header"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }